module.exports = __webpack_public_path__ + "static/media/14UNEP20.c76f8f25.jpg";